import React from 'react';
import { Tooltip } from 'react-tooltip';

import { ReactComponent as CopyLink } from '@assets/svg/copyLink-icon.svg';

import { showToast } from '@helpers/showToast';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const BtnHeaderCopyLink = () => {
  const { t } = useTranslation();

  const handleCopyLink = () => {
    const url = window.location.href;

    try {
      navigator.clipboard.writeText(url).then(() => {
        showToast({ variant: 'success', message: t('Successfully copied to clipboard') });
      });
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <>
      <CopyLink id="header-copy-link" className={style.copyLinkIcon} onClick={handleCopyLink} />
      <Tooltip anchorSelect="#header-copy-link" content={t('Share')} />
    </>
  );
};

export default BtnHeaderCopyLink;
